module.exports = __webpack_public_path__ + "static/media/logo.09ab83d4.svg";